

export default {
  getStyle: state => state.style,
  getCenter: state => state.center,
  getZoom: state => state.zoom,
  getDefaultPosition: state => state.defaultPosition,
  getVesselCategories: state => state.vessel_categories,
  getPlotCategories: state => state.plot_categories,
}
